"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDED_SUBSCRIPTIONS = exports.ADD_SUBSCRIPTIONS = exports.CONTAINER_IS_TERMINATING = exports.FORCE_USER_LOGOUT = void 0;
exports.FORCE_USER_LOGOUT = 'FORCE_USER_LOGOUT';
exports.CONTAINER_IS_TERMINATING = 'CONTAINER_IS_TERMINATING';
exports.ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
exports.ADDED_SUBSCRIPTIONS = 'ADDED_SUBSCRIPTIONS';
